import styled from 'styled-components';
import { InputBox } from '@/components/UI/Input/Input.styles';

export const SearchWrapper = styled.div`
  flex: 1 1 auto;
  min-width: 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex: 1 1 auto;
    max-width: 400px;
  }
`;

export const SearchField = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 44px;
  border-radius: 12px;
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
  background: ${({ theme }) => theme.palette.primary.background};
  transition: border-color 0.15s ease, background 0.15s ease;

  &:focus-within {
    border: 1px solid ${({ theme }) => theme.palette.brand.main};
    background: ${({ theme }) => theme.palette.primary.background};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    height: 42px;
    border-radius: 14px;
  }
`;

export const SearchIconWrap = styled.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 14px;
  color: ${({ theme }) => theme.palette.secondary.labels};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-left: 12px;
  }
`;

export const SearchInput = styled(InputBox).attrs({
  type: 'search',
})`
  width: 100%;
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0 14px 0 8px;
  border: none;
  background: transparent;
  border-radius: 0;

  &:focus {
    outline: none;
    border: none;
    box-shadow: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-left: 6px;
    font-size: 14px;

    &::placeholder {
      color: ${({ theme }) => theme.palette.secondary.labels};
    }
  }
`;
